import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Panel, Ok, When } from "./Panel";

const DomainRow = ({ d }) => (
  <tr className="border-t align-top"><td className="p-1 font-medium">{d.subdomain}.{d.domain} <span className="text-slate-400">#{d.id}</span></td>
    <td className="p-1">{d.valid ? "valid" : "INVALID"}</td><td className="p-1">{d.default ? "yes" : ""}</td><td className="p-1">{d.used_by_tedops ? "TedOps" : "not TedOps"}</td>
    <td className="p-1">{d.records.map((r) => <div key={r.name}>{r.name}: {r.live_matches ? "DNS ok" : "DNS missing/different"}</div>)}</td></tr>
);

export const AuthAuditPanel = ({ admin, last, onChange }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await api.post("/email-marketing/launch/sendgrid-auth-audit"); toast.success("Audit started — refresh in about a minute"); setTimeout(onChange, 45000); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not start"); }
    setBusy(false);
  };
  return (
    <Panel testid="launch-auth" title="3. SendGrid authentication & Microsoft blocks" right={<div className="flex items-center gap-2"><When at={last?.at} />
      {admin && <Button size="sm" variant="outline" disabled={busy} onClick={run} data-testid="auth-run-btn">Run audit</Button>}</div>}
      sub="Compares every SendGrid domain-authentication record (em7761, em3369, em6509…) with live DNS, shows which one TedOps uses, and checks whether the historical blocks match any TedOps sends. Nothing is changed or removed.">
      {last?.status === "running" && <p className="text-xs text-slate-500">Running…</p>}
      {last?.status === "failed" && <p className="text-xs text-red-600">{last.error}</p>}
      {last?.status === "done" && <div className="space-y-2" data-testid="auth-result">
        <div className="overflow-x-auto"><table className="w-full text-xs"><thead><tr className="text-left text-slate-400"><th className="p-1">Record</th><th className="p-1">SendGrid</th><th className="p-1">Default</th><th className="p-1">Used by</th><th className="p-1">Live DNS</th></tr></thead>
          <tbody>{last.domains.map((d) => <DomainRow key={d.id} d={d} />)}</tbody></table></div>
        <ul className="text-xs list-disc pl-5 text-slate-700">{last.conclusions.map((c) => <li key={c}>{c}</li>)}</ul>
        {last.risks.length ? last.risks.map((r) => <Ok key={r} ok={false}>{r}</Ok>) : <Ok ok>TedOps sending authentication passes (SendGrid and live DNS)</Ok>}
        {(last.warnings || []).map((w) => <p key={w} className="text-[11px] text-amber-700">Not used by TedOps, left unchanged: {w}</p>)}
        <p className="text-[11px] text-slate-500">DMARC: {JSON.stringify(last.root_dns?.dmarc)} · Other webhooks: {last.webhooks.filter((w) => w.owner !== "tedops").map((w) => w.name || w.url).join(", ") || "none"} · API keys: {last.api_keys.map((k) => k.name).join(", ") || "n/a"}</p>
      </div>}
    </Panel>
  );
};
